/** XVideos' 38 main categories (its own curated pages, /c/<slug>, read from xvideos.com/tags on 2026-10-25). They are different lists from a
 * search for the same word (Blonde: 5 of about 25 videos in common). Pages: /c/<slug>, /c/<slug>/1, /c/<slug>/2...; sorting: /c/s:views/<slug>/<page>. */
export const XVIDEOS_CATEGORIES = [
{ slug: "AI-239", label: "AI" },
{ slug: "Amateur-65", label: "Amateur" },
{ slug: "Anal-12", label: "Anal" },
{ slug: "Arab-159", label: "Arab" },
{ slug: "Asian_Woman-32", label: "Asian Woman" },
{ slug: "ASMR-229", label: "ASMR" },
{ slug: "Ass-14", label: "Ass" },
{ slug: "bbw-51", label: "bbw" },
{ slug: "Bi_Sexual-62", label: "Bi Sexual" },
{ slug: "Big_Ass-24", label: "Big Ass" },
{ slug: "Big_Cock-34", label: "Big Cock" },
{ slug: "Big_Tits-23", label: "Big Tits" },
{ slug: "Black_Woman-30", label: "Black Woman" },
{ slug: "Blonde-20", label: "Blonde" },
{ slug: "Blowjob-15", label: "Blowjob" },
{ slug: "Brunette-25", label: "Brunette" },
{ slug: "Cam_Porn-58", label: "Cam Porn" },
{ slug: "Creampie-40", label: "Creampie" },
{ slug: "Cuckold-237", label: "Cuckold" },
{ slug: "Cumshot-18", label: "Cumshot" },
{ slug: "Femdom-235", label: "Femdom" },
{ slug: "Fisting-165", label: "Fisting" },
{ slug: "Fucked_Up_Family-81", label: "Fucked Up Family" },
{ slug: "Gangbang-69", label: "Gangbang" },
{ slug: "Gapes-167", label: "Gapes" },
{ slug: "Indian-89", label: "Indian" },
{ slug: "Interracial-27", label: "Interracial" },
{ slug: "Latina-16", label: "Latina" },
{ slug: "Lesbian-26", label: "Lesbian" },
{ slug: "Lingerie-83", label: "Lingerie" },
{ slug: "Mature-38", label: "Mature" },
{ slug: "Milf-19", label: "Milf" },
{ slug: "Oiled-22", label: "Oiled" },
{ slug: "Redhead-31", label: "Redhead" },
{ slug: "Solo_and_Masturbation-33", label: "Solo and Masturbation" },
{ slug: "Squirting-56", label: "Squirting" },
{ slug: "Stockings-28", label: "Stockings" },
{ slug: "Teen-13", label: "Teen" },
] as const
